<h3>抗疫基金</h3>

  <ul>

    <li i18n="@@smartCovid_1">
      Window mounted negative pressure isolation room machine
    </li>
    <li i18n="@@smartCovid_2">
      Disinfection hand dryers
    </li>
    <li i18n="@@smartCovid_3">
      Disinfection water in pipes
    </li>
    <li i18n="@@smartCovid_4">
      Disinfection floor blower
    </li>
  </ul>

